import application from 'application/application';

import moment from 'moment';

application

	.directive('ngDate', () => ({
		restrict: 'A',
		require: 'ngModel',
		link(scope, element, attrs, controller) {

			controller.$validators.date = modelValue => {

				if (controller.$isEmpty(modelValue))

					return true;

				return moment(modelValue, (attrs.ngDateFormat || 'DD/MM/YYYY'), true).isValid();

			};

		}
	}));
